module.exports = __webpack_public_path__ + "img/train_toy.be5030ca.webp";